const name = 'VueColor';
// 自定义组件前缀
const prefix = '';
const cssPrefix = '';
const size = 'medium';

export {
  name,
  prefix,
  size,
  cssPrefix,
};
